// TODO: NEED IT UNTIL WE SWITCH UI TO USE PIF COMPILER
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export async function downloadPifCompilerDiagnostics(
  diagnostics: string,
  dataForCompiling: string,
  rows: string
) {
  const zip = new JSZip();

  zip.file('diagnostics.json', diagnostics);
  zip.file('data_for_compiling.json', dataForCompiling);
  zip.file('rows.json', rows);

  const content = await zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: { level: 6 },
  });

  saveAs(content, 'agent-compiler-data.zip');
}
